import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faQuoteLeft, faStar } from '@fortawesome/free-solid-svg-icons';

export const clientReviews = [
    {
        quote: 'DecklePro has made our reel planning much faster and more accurate. It has helped us reduce manual work and improve production efficiency.',
        role: 'Production Head',
        company: 'Sezon Paper Pvt. Ltd.',
        accent: 'var(--anmatics-blue)'
    },
    {
        quote: 'We have been using DecklePro for over a year and are very satisfied with the results. The software is simple to use and helps us optimize reel utilization effectively.',
        role: 'Director of Operations',
        company: 'Brownfold Paper LLP',
        accent: 'var(--anmatics-teal)'
    },
    {
        quote: 'Even in the first month, DecklePro has simplified our planning process. The software is user-friendly, and the support team has been very helpful.',
        role: 'Production Head',
        company: 'Shweta Paper Pvt. Ltd.',
        accent: 'var(--anmatics-purple)'
    }
];

const ClientReviews = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        if (clientReviews.length <= 1) return undefined;

        const interval = window.setInterval(() => {
            setActiveIndex((current) => (current + 1) % clientReviews.length);
        }, 5000);

        return () => window.clearInterval(interval);
    }, []);

    const goToReview = (index) => {
        setActiveIndex((index + clientReviews.length) % clientReviews.length);
    };

    return (
        <section className="client-reviews-section py-5">
            <div className="container">
                <div className="row align-items-end g-4 mb-4">
                    <div className="col-lg-7">
                        <span className="section-kicker">Client Reviews</span>
                        <h2 className="section-title text-start mb-0">What Clients Say</h2>
                    </div>
                    <div className="col-lg-5">
                        <div className="client-review-controls" aria-label="Client review controls">
                            <button
                                type="button"
                                className="client-review-control"
                                aria-label="Previous review"
                                onClick={() => goToReview(activeIndex - 1)}
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <button
                                type="button"
                                className="client-review-control"
                                aria-label="Next review"
                                onClick={() => goToReview(activeIndex + 1)}
                            >
                                <FontAwesomeIcon icon={faArrowRight} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="client-review-carousel" aria-live="polite">
                    <div
                        className="client-review-track"
                        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                    >
                        {clientReviews.map((review) => (
                            <div className="client-review-slide" key={review.company}>
                                <article className="client-review-card" style={{ '--review-accent': review.accent }}>
                                    <div className="client-review-topline">
                                        <span className="client-review-quote-icon">
                                            <FontAwesomeIcon icon={faQuoteLeft} />
                                        </span>
                                        <div className="client-review-stars" aria-label="Positive client review">
                                            {[1, 2, 3, 4, 5].map((star) => (
                                                <FontAwesomeIcon icon={faStar} key={star} />
                                            ))}
                                        </div>
                                    </div>
                                    <p className="client-review-quote">"{review.quote}"</p>
                                    <div className="client-review-author">
                                        <strong>{review.role}</strong>
                                        <span>{review.company}</span>
                                    </div>
                                </article>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="client-review-dots" aria-label="Client reviews">
                    {clientReviews.map((review, index) => (
                        <button
                            type="button"
                            className={`client-review-dot ${index === activeIndex ? 'active' : ''}`}
                            aria-label={`Show review from ${review.company}`}
                            aria-current={index === activeIndex ? 'true' : undefined}
                            key={review.company}
                            onClick={() => goToReview(index)}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ClientReviews;
